var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('iframe',{staticStyle:{"width":"100%","height":"var(--dynamic-vh)"},attrs:{"title":"privacy","src":_vm.src,"frameborder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }